import { Map } from 'immutable';
import core from './core';

const INITIAL_STATE = new Map({
    list: new Map(),
    initialized: false,
    prefixCenter: ''
});
export default (env, state = INITIAL_STATE, action) => {
    switch (action.type) {
        case `${env.toUpperCase()}__SET_BOXES`:
            return core.setBoxes(state, action.boxes);
        case `${env.toUpperCase()}__UPDATE_BOX`:
            return core.updateBox(state, action.boxMac, action.box);
        case `${env.toUpperCase()}__UPDATE_BOX_STATUS`:
            return core.updateBoxStatus(state, action.macAddress, action.boxIsConnected);
        case `${env.toUpperCase()}__SET_PREFIX_CENTER`:
            return core.setPrefixCenter(state, action.prefixCenter);
        case `${env.toUpperCase()}__UPDATE_BOX_IP`:
            return core.updateBoxIp(state, action.macAddress, action.ipAddress);
        case `${env.toUpperCase()}__UPDATE_BOX_SYS_INFO`:
            return core.updateBoxSysInfo(state, action.macAddress, action.boxSysInfo);
        case `${env.toUpperCase()}__UPDATE_BOX_CONFIG_OVERRIDE`:
            return core.updateBoxConfigOverride(state, action.macAddress, action.config);
        case `${env.toUpperCase()}__UPDATE_BOX_UPGRADE`:
            return core.updateBoxUpgrade(state, action.macAddress, action.upgrade);
        case `${env.toUpperCase()}__SWAP_BOX`:
            return core.swapBox(state, action.payload);
        case `${env.toUpperCase()}__UPDATE_BOX_STATE`:
            return core.updateBoxState(state, action.payload);
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./environments/genericEnv/data/Boxes/reducer.js